<template>
  <aha-textarea
    id="ai-prompt-input"
    class="ai-prompt-input"
    :class="{'is-aha-gpt-enabled': isAhaSlidesGPTEnabled}"
    :max-length="promptMaxLength"
    :placeholder="$i18nPresenter.t('Enter your prompt…')"
    v-model="aiPromptInput"
    hasButtonAtStart
    hasButtonOnEnd
    preventEnterNewLine
    @buttonClick="generateOrStopGeneratingSlides('Button clicked')"
    @buttonAtStartClick="clickOnAIPromptInputAttachmentButton()"
    @keyupEnter="onEnterAIPromptInput()"
  >
    <!-- ATTACHMENT BUTTON -->
    <template #buttonAtStart>
      <div
        v-aha-emit-action
        name="ai_prompt_input_attachment_button"
      >
        <aha-icon
          name="clip"
          class="doc-to-quiz__upload-icon"
          :class="{'disabled': isDocToSlideGenerating}"
          v-tooltip="docToQuizAttachmentTooltip"
        ></aha-icon>
        <div class="aha-textarea__button-bg" :class="{'hidden': isDocToSlideGenerating}"></div>
      </div>
    </template>

    <template #button>
      <slot name="button">
        <AIGenerateAndStopButton
          :isDoneGenerating="isDoneGenerating"
          :isSendingAIRequest="isSendingAIRequest"
          :isAIRequestingOrGeneratingSlides="isAIRequestingOrGeneratingSlides"
          :isGenerateButtonDisabled="isGenerateButtonDisabled"
          v-aha-emit-action
        />
      </slot>
    </template>
  </aha-textarea>
</template>

<script>
import { mapGetters } from 'vuex'
import AIGenerateAndStopButton from '@/components-v2/openAI/AIGenerateAndStopButton.vue'

export default {
  components: {
    AIGenerateAndStopButton,
  },
  props: {
    isSendingAIRequest: {
      type: Boolean,
      default: false,
    },
    isDoneGenerating: {
      type: Boolean,
      default: false,
    },
    isDocToSlideGenerating: {
      type: Boolean,
      default: false,
    },
    isAhaSlidesGPTEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      aiPromptInput: '',
    }
  },

  computed: {
    ...mapGetters('promptToSlideGenerator', [
      'promptMaxLength',
      'isSendingAIRequestFeedback', 'isAIRequestingOrGeneratingSlides',
      'isReturnedSlideError']),

    docToQuizAttachmentTooltip() {
      if (!this.isDocToSlideGenerating) return this.$i18nPresenter.t('Upload file')
      return this.$i18nPresenter.t('A quiz is currently generating. Please wait to use this feature.')
    },

    hasNoPrompt() {
      return !this.aiPromptInput || (this.aiPromptInput && !this.aiPromptInput.trim().length)
    },

    isGenerateButtonDisabled() {
      return this.isAIRequestingOrGeneratingSlides || this.hasNoPrompt
    },
  },

  methods: {
    clickOnAIPromptInputAttachmentButton() {
      this.$emit('clickOnAIPromptInputAttachmentButton')
    },

    generateOrStopGeneratingSlides(mode) {
      if (!this.isDoneGenerating) {
        this.$emit('clickOnStopGeneratingSlidesButton')
      } else {
        this.$emit('clickOnGenerateSlidesButton', this.aiPromptInput, mode)
        this.aiPromptInput = ''
      }
    },

    onEnterAIPromptInput() {
      if (this.isGenerateButtonDisabled) return
      this.$emit('enterAIPromptInput', this.aiPromptInput, 'Enter')
      this.aiPromptInput = ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.ai-prompt-input {
  @apply w-full z-1;
  max-width: calc($right-panel-width - ($right-panel-content-px * 2));
  height: 64px;
  max-height: 64px;
  &::v-deep {
    .aha-textarea {
      @apply w-full h-full text-sm resize-none;
      padding: 0.6rem 2.3rem 0.6rem 2.25rem;
    }
    .aha-textarea-limit {
      @apply hidden;
    }
    .aha-textarea-button {
      @apply absolute top-3;
      right: 0.2rem;
      &:has(.generator_stop-icon) {
        @apply right-2 top-4;
      }
    }
    .aha-textarea__button-at-start {
      @apply absolute left-2 cursor-pointer top-3;
      .doc-to-quiz__upload-icon {
        @apply text-secondary-100 absolute;
        left: 1.5px;
        top: 1.5px;
        z-index: 1;
      }
      &:hover, &:active {
        .aha-textarea__button-bg {
          @apply bg-secondary-15 rounded-full absolute opacity-100;
          width: 32px;
          height: 32px;
          z-index: 0;
          left: -5px;
          top: -4px;
        }
      }
    }
  }
  &.is-aha-gpt-enabled {
    @apply mb-2;
  }
}
</style>
